
import React from 'react';
import { CheckCircle } from 'lucide-react';

interface FormStatusIndicatorProps {
  status: 'success' | 'error';
}

const FormStatusIndicator: React.FC<FormStatusIndicatorProps> = ({ status }) => {
  if (status === 'success') {
    return (
      <div className="flex items-center space-x-2 text-green-600 mt-4">
        <CheckCircle className="h-5 w-5" />
        <span>Your message has been sent successfully!</span>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div className="flex items-center space-x-2 text-red-600 mt-4">
        <span>There was an error submitting your message. Please try again.</span>
      </div>
    );
  }

  return null;
};

export default FormStatusIndicator;
